import { CHANGE_VALUES, GET_VALUES, GET_VALUES_FOR_TABLE } from './projectionsTypes'

const initialState = { valuesForTable: { data: [], query: {} } }

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_VALUES:
      return {
        ...state,
        values: {
          ...state.values,
          [action.payload.name]: action.payload.newValue,
        },
      }
    case GET_VALUES:
      return {
        ...state,
        values: action.payload,
      }
    case GET_VALUES_FOR_TABLE:
      return {
        ...state,
        valuesForTable: action.payload,
      }
    default:
      return state
  }
}
